/** Props for {@link AgentAiIcon}. */
interface AgentAiIconProps {
  width?: number;
  height?: number;
  /** Background fill for the outer circle and inner clip rect. Defaults to `#004839`. */
  fill?: string;
}

/**
 * Renders the agent AI avatar icon used in worklist tooltips and status UI.
 *
 * @param props.width - SVG width in pixels
 * @param props.height - SVG height in pixels
 * @param props.fill - Background fill color for the circular badge
 * @returns The agent AI SVG icon
 */
export const AgentAiIcon = ({
  width = 24,
  height = 24,
  fill = "#004839",
}: AgentAiIconProps) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="12" fill={fill} />
        <g clipPath="url(#clip0_2777_8979)">
          <rect width="12" height="12" transform="translate(6 6)" fill={fill} />
          <path
            d="M9.37049 17.7346C9.57317 17.7346 9.78068 17.7334 9.99272 17.7334H14.0065C14.2183 17.7334 14.4258 17.7346 14.6285 17.7346C16.4856 17.7346 17.9047 17.6396 17.9047 15.6981C17.9047 13.666 16.3506 11.9978 14.3659 11.8164C14.3501 12.5273 12.0003 14.2818 12.0003 14.2818C12.0003 14.2818 9.64989 12.5275 9.63396 11.8166C7.6495 11.9978 6.09509 13.666 6.09509 15.6981C6.09509 17.6396 7.51359 17.7346 9.37049 17.7346ZM13.7534 15.0833C13.7534 15.0255 13.8056 14.9788 13.8705 14.9788H14.5053V14.3443C14.5053 14.28 14.5516 14.2273 14.6095 14.2273H15.2359C15.2935 14.2273 15.3401 14.2796 15.3401 14.3443V14.979H15.9746C16.0389 14.979 16.0915 15.0256 16.0915 15.0835V15.7097C16.0915 15.7675 16.0394 15.8141 15.9746 15.8141H15.34V16.4486C15.34 16.5132 15.2932 16.5655 15.2355 16.5655H14.6093C14.5514 16.5655 14.5048 16.5134 14.5048 16.4486V15.814H13.8703C13.8057 15.814 13.7533 15.7674 13.7533 15.7095L13.7534 15.0833Z"
            fill="white"
          />
          <rect
            x="9.2424"
            y="7.60156"
            width="5.08765"
            height="2.40994"
            fill={fill}
          />
          <ellipse
            cx="11.1167"
            cy="8.40664"
            rx="0.535542"
            ry="0.535543"
            fill="white"
          />
          <path
            d="M7.63559 8.24953V9.10015C7.63559 9.33503 7.82601 9.52546 8.0609 9.52546H8.20266V7.82422H8.0609C7.82601 7.82422 7.63559 8.01464 7.63559 8.24953ZM15.7164 7.82422H15.5747V9.52546H15.7164C15.9513 9.52546 16.1418 9.33503 16.1418 9.10015V8.24953C16.1418 8.01464 15.9513 7.82422 15.7164 7.82422Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.441 6.26562H9.33731C8.86753 6.26562 8.48669 6.64646 8.48669 7.11624V10.2352C8.48669 10.7038 8.86572 11.0841 9.33434 11.0858L11.2661 11.0858H14.441C14.9108 11.0858 15.2916 10.705 15.2916 10.2352V7.11623C15.2916 6.64646 14.9108 6.26562 14.441 6.26562ZM11.8892 9.80984C12.4924 9.80984 12.7093 9.474 12.7182 9.45968C12.7378 9.42824 12.7442 9.39035 12.736 9.35424C12.7278 9.31812 12.7057 9.28668 12.6745 9.26673C12.6431 9.24668 12.605 9.23972 12.5685 9.24732C12.532 9.25492 12.4999 9.27648 12.4791 9.30742C12.4731 9.31634 12.3259 9.5263 11.8892 9.5263C11.4562 9.5263 11.3079 9.31989 11.2994 9.3077C11.2789 9.27667 11.2471 9.25492 11.2107 9.24714C11.1744 9.23935 11.1364 9.24616 11.1051 9.26609C11.0737 9.28602 11.0514 9.31748 11.043 9.35369C11.0346 9.3899 11.0407 9.42796 11.0601 9.45968C11.069 9.474 11.2859 9.80984 11.8892 9.80984Z"
            fill="white"
          />
          <ellipse
            cx="10.5802"
            cy="8.40664"
            rx="0.535542"
            ry="0.535543"
            fill={fill}
          />
          <ellipse
            cx="13.2604"
            cy="8.40664"
            rx="0.535542"
            ry="0.535543"
            fill={fill}
          />
        </g>
        <defs>
          <clipPath id="clip0_2777_8979">
            <rect
              width="12"
              height="12"
              fill="white"
              transform="translate(6 6)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
